import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

// MUST be module-level — not inside the component, not inline in the hook call
const GOOGLE_MAPS_LIBRARIES = ["places"];

const GoogleMapsContext = createContext({ isLoaded: false, loadError: null });

export const GoogleMapsProvider = ({ children }) => {
    const { isLoaded, loadError } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: GOOGLE_MAPS_LIBRARIES,
    });

    console.log("isLoaded:", isLoaded);
console.log("loadError:", loadError);
console.log("API Key:", process.env.REACT_APP_GOOGLE_MAPS_API_KEY);

    return (
        <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
            {children}
        </GoogleMapsContext.Provider>
    );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);